export default function NextDateIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.65797 4.91128C7.35009 4.63419 6.87587 4.65914 6.59878 4.96703C6.32169 5.27491 6.34664 5.74913 6.65453 6.02622L7.65797 4.91128ZM9.96875 8L10.4705 8.55747C10.6285 8.41524 10.7188 8.21262 10.7188 8C10.7188 7.78738 10.6285 7.58476 10.4705 7.44253L9.96875 8ZM6.65453 9.97378C6.34664 10.2509 6.32169 10.7251 6.59878 11.033C6.87587 11.3409 7.35009 11.3658 7.65797 11.0887L6.65453 9.97378ZM14 8C14 11.3137 11.3137 14 8 14V15.5C12.1421 15.5 15.5 12.1421 15.5 8H14ZM8 14C4.68629 14 2 11.3137 2 8H0.5C0.5 12.1421 3.85786 15.5 8 15.5V14ZM2 8C2 4.68629 4.68629 2 8 2V0.5C3.85786 0.5 0.5 3.85786 0.5 8H2ZM8 2C11.3137 2 14 4.68629 14 8H15.5C15.5 3.85786 12.1421 0.5 8 0.5V2ZM6.65453 6.02622L9.46703 8.55747L10.4705 7.44253L7.65797 4.91128L6.65453 6.02622ZM9.46703 7.44253L6.65453 9.97378L7.65797 11.0887L10.4705 8.55747L9.46703 7.44253Z"
        fill="currentColor"
      />
    </svg>
  );
}
